import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ภาษีมูลค่าเพิ่ม (VAT) — จดทะเบียน ยื่น ภ.พ.30 และ Refund","metaTitle":"จดทะเบียน VAT + ยื่น ภ.พ.30 รายเดือน — Full-Service | NYC","metaDesc":"บริการจดทะเบียน VAT (ภ.พ.01), ยื่น ภ.พ.30 รายเดือน, ขอคืน VAT (ภ.พ.30.2), และเตรียมสอบบัญชี VAT สำหรับ SME และบริษัทต่างชาติในไทย"},"en":{"h1":"Thailand VAT — Registration, PP.30 Filing, Refund & VES","metaTitle":"Thailand VAT Service — Registration, PP.30 Monthly Filing | NYC","metaDesc":"Full Thai VAT lifecycle: PP.01 registration, monthly PP.30 filing, PP.30.2 refunds, PP.30.9 VES for foreign e-service providers."}} as const;

export const Route = createFileRoute("/en/tax/vat")({
  head: () => {
    const url = `${SEO_SITE}/en/tax/vat`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/tax/vat", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/tax/vat", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/tax/vat", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/tax/vat", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/tax/vat", "/en/tax/vat")],
    };
  },
  component: () => <SubServicePage slug="tax/vat" locale="en" />,
});
